module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1018-b21f2603b2f75bcb6edae2402ce02b17.png";